import React from "react";

import { Row, Col, Input, Form } from "antd";
import CloneRateCardTemplate from "./CloneRateCardTemplate";
const MasterRateForm = ({
  disable,
  getTemplateDetails = () => {},
  hideCloneTemplate = false,
}) => {
  return (
    <div>
      <Row className="global-form-row p-1" gutter={20}>
        <Col span={1} />
        <Col span={8}>
          <Form.Item
            name="name"
            label="Template Name"
            rules={[
              {
                required: true,
                message: "Please enter template name",
              },
            ]}
          >
            <Input placeholder="Enter template name" disabled={disable} />
          </Form.Item>
        </Col>
        <Col span={8}>
          {!hideCloneTemplate && (
            <Form.Item name="templateId" label="Clone From Existing Template">
              <CloneRateCardTemplate
                getTemplateData={(data) => getTemplateDetails(data)}
              />
            </Form.Item>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MasterRateForm;
